import { splunkInstance } from '@/common/services/splunk';

/**
 * Funnel events for the chat-recovery feature (design §9). Everything the patient
 * touches lands in Splunk under one group so acceptance/abandonment rates are
 * queryable per doctor (doctor_user_id rides along in every payload).
 */
export const CHAT_RECOVERY_EVENT_GROUP = 'chat_recovery';

export type ChatRecoveryEventType =
  | 'impression'
  | 'dismiss'
  | 'cancel_clicked'
  | 'switch_clicked'
  | 'confirm_viewed'
  | 'confirmed'
  | 'confirm_dismissed'
  | 'result_seen'
  | 'new_chat_opened'
  | 'switch_abandoned';

export function sendChatRecoveryEvent(
  type: ChatRecoveryEventType,
  event: Record<string, unknown>
): void {
  try {
    splunkInstance('booking').sendEvent({
      group: CHAT_RECOVERY_EVENT_GROUP,
      type: `ov_recovery_${type}`,
      event,
    });
  } catch {
    // Telemetry must never break the flow.
  }
}
